export default __webpack_public_path__ + "static/meshery-architecture-dd8e74ef659c02732c6867ed6f049c98.webp";